module.exports = __webpack_public_path__ + "static/OpenSans-SemiBold-5e8ca8c102c0d8c82ac200488a4e4ae5.woff";